import { BaseRouteService } from 'core/services';

class ReturnAddressRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'return-address/';
	}

	find(filter) {
		return super.find(this.base + 'search', filter);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete() {
		return super.delete(this.base);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}
}

export default ReturnAddressRouteService;
